import React, { useMemo } from 'react';
import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Navigate, Route, Routes } from 'react-router-dom';

import AppTabs from '../../../components/designe/app-tabs/AppTabs';
import { useAccess } from '../../../hooks/useAccess';
import { Paths } from '../../../shared/paths';
import BugReportTypes from '../bug-report-types/BugReportTypes';
import AppVariables from '../app-variables/AppVariables';
import AppFeatures from '../app-features/AppFeatures';
import TrainingActivityTypes from '../training-activity-types/TrainingActivityTypes';

export function AppConfigurationInnerTabs() {
  const { t } = useTranslation();
  const { access } = useAccess();
  const base = `${Paths.adminDashboard.root}${Paths.adminDashboard.appConfiguration}`;
  const canViewBugReportTypes = access?.bugReports?.canViewType ?? false;
  const canViewAppVariables = access?.appVariables?.canView ?? false;
  const canViewAppFeatures = access?.appFeatures?.canView ?? false;
  const canViewTrainingActivityTypes =
    access?.trainingActivityTypes?.canView ?? false;

  const tabsConfig = useMemo(() => {
    const tabs = [];

    if (canViewBugReportTypes) {
      tabs.push({
        label: t('adminDashboard.bugReportTypes'),
        path: `${base}/bug-report-types`,
      });
    }

    if (canViewAppVariables) {
      tabs.push({
        label: t('adminDashboard.appVariables'),
        path: `${base}/app-variables`,
      });
    }

    if (canViewAppFeatures) {
      tabs.push({
        label: t('adminDashboard.appFeatures'),
        path: `${base}/app-features`,
      });
    }

    if (canViewTrainingActivityTypes) {
      tabs.push({
        label: t('adminDashboard.trainingActivityTypes'),
        path: `${base}/training-activity-types`,
      });
    }

    return tabs;
  }, [
    base,
    canViewAppFeatures,
    canViewAppVariables,
    canViewBugReportTypes,
    canViewTrainingActivityTypes,
    t,
  ]);

  const defaultTab =
    tabsConfig[0]?.path?.replace(`${base}/`, '')?.replace(/^\/+/, '') || '';

  return (
    <>
      <AppTabs config={tabsConfig} />
      <Box sx={{ mt: 2 }}>
        <Routes>
          {canViewBugReportTypes && (
            <Route path="bug-report-types" element={<BugReportTypes />} />
          )}
          {canViewAppVariables && (
            <Route path="app-variables" element={<AppVariables />} />
          )}
          {canViewAppFeatures && (
            <Route path="app-features" element={<AppFeatures />} />
          )}
          {canViewTrainingActivityTypes && (
            <Route
              path="training-activity-types"
              element={<TrainingActivityTypes />}
            />
          )}
          <Route
            index
            element={<Navigate to={defaultTab || Paths.root} replace />}
          />
        </Routes>
      </Box>
    </>
  );
}
